module.exports = __webpack_public_path__ + "img/img9.c9b558de.jpg";